export default __webpack_public_path__ + "894f3c22a68a382bf4517e0d2813d063.ttf";